//#region Imports

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconComponent } from '../icon/icon.component';

//#endregion

@Component({
  selector: 'l-table-paginator',
  templateUrl: './table-paginator.component.html',
  imports: [IconComponent],
})
export class TablePaginatorComponent {

  //#region Inputs

  @Input({ required: true })
  public isFirstPage = false;

  @Input({ required: true })
  public isLastPage = false;

  @Input({ required: true })
  public currentPage = 1;

  @Input({ required: true })
  public totalPages = 1;

  //#endregion

  //#region Outputs

  @Output()
  public firstPageClick = new EventEmitter<void>();

  @Output()
  public prevPageClick = new EventEmitter<void>();

  @Output()
  public nextPageClick = new EventEmitter<void>();

  @Output()
  public lastPageClick = new EventEmitter<void>();

  //#endregion

}
